"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RX_IDENTITY = exports.RX_PHONES = exports.RX_PHONE_PREFIXES = exports.RX_PASSWORD = exports.RX_EMAIL = exports.RX_ALPHA = void 0;

var _RX_PHONES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// RegExp
var RX_ALPHA = '^[a-zA-Z]+$';
exports.RX_ALPHA = RX_ALPHA;
var RX_EMAIL = '^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$';
exports.RX_EMAIL = RX_EMAIL;
var RX_PASSWORD = ['^', '(?=.*\\d)', // one number
'(?=.*[a-zA-Z])', // one alphabet
'[A-Za-z\\d\\:\\;\\"\\\'\\+\\=\\-\\_\\\\\\|\\{\\[\\}\\]\\<\\>\\.\\,\\/\\?\\|', '\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)]', '{6,}', // 6 characters
'$'].join('');
exports.RX_PASSWORD = RX_PASSWORD;
var RX_PHONE_PREFIXES = {
  IN: '^62$',
  MY: '^60$',
  SG: '^65$'
}; // Complicated RegExp
// use String(62) to avoid `Non-string literal property keys not supported` warning

exports.RX_PHONE_PREFIXES = RX_PHONE_PREFIXES;
var RX_PHONES = (_RX_PHONES = {}, _defineProperty(_RX_PHONES, String(62), {
  // indonesia
  false: '^[2-9]\\d{10,}$',
  true: '^08\\d{9,10}$'
}), _defineProperty(_RX_PHONES, String(60), {
  // malaysia
  false: '^[2-9]\\d{7,8}$',
  true: '^1\\d{8,9}$'
}), _defineProperty(_RX_PHONES, String(65), {
  // singapore
  false: '^[6]\\d{7}$',
  true: '^[89]\\d{7}$'
}), _RX_PHONES);
exports.RX_PHONES = RX_PHONES;
var RX_IDENTITY = {
  MY: {
    ic_number: '^([0-9][0-9])((0[1-9])|(1[0-2]))((0[1-9]|[1-2][0-9]|3[0-1]))([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^\\w*$'
  },
  ID: {
    ic_number: '^(1[1-9]|21|3[1-6]|5[1-3]|6[1-5]|7[1-6]|8[1-2]|9[1-2])([0-2][0-9]|7[0-9])([0-9][0-9])(0[1-9]|1[1-9]|2[1-9]|3[0-1]|4[1-9]|5[1-9]|6[1-9]|7[0-1])(0[1-9]|1[1-2])([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^\\w*$'
  }
};
exports.RX_IDENTITY = RX_IDENTITY;